import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const Layout = ({ children }) => (
  <div className="flex flex-col min-h-screen">
    <Header />
    <div className="flex-grow min-h-screen my-10">{children}</div>
    <Footer />
  </div>
);

export default Layout;
